module.exports = __webpack_public_path__ + "search-icon-e2d083cbce09af72d74aa65dd1276e3b.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/svg/search-icon.svg
// module id = 1954
// module chunks = 0 6